import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import clsx from "clsx";
import useTranslationHook from "../../hooks/useTranslationHook";
import { useNavigate } from "react-router-dom";
import { useScrollLock } from "../../hooks/useScrollLock";
import { getCustomerInfoFromStroge } from "../../shared/helpersMethod";
import MenuCart from "./sub-components/MenuCart";
import SearchInput from './sub-components/SearchInput';
import HeartEmpty from "../../assets/svgs/HeartEmpty";
import {ReactComponent as HeartIcon} from '../../assets/svgs/heart.svg';
import {ReactComponent as ShoppingBagIcon} from '../../assets/svgs/bag-handle-outline.svg';
import {ReactComponent as SearchIconHeader} from '../../assets/svgs/search.svg'
import {ReactComponent as PersonIconHeader} from '../../assets/svgs/person.svg'
import { Hamburger } from "../../assets/svgs/svgs";
const IconGroup = ({ iconWhiteClass }) => {
  const navigation = useNavigate();
  const { t } = useTranslationHook();
  const { lockScroll } = useScrollLock();
  const customerInfo = getCustomerInfoFromStroge();
  const handleClick = (e) => {
    e.currentTarget.nextSibling.classList.toggle("active");
  };
  const navigateToCart = () => {
    navigation( "/cart");
   
  }
  const handleClickAccount = () => {
    navigation(process.env.PUBLIC_URL + "/my-account");
    // e.currentTarget.nextSibling.classList.toggle("active");
  };

  const triggerMobileMenu = () => {
    const offcanvasMobileMenu = document.querySelector(
      "#offcanvas-mobile-menu"
    );
    offcanvasMobileMenu.classList.add("active");
     const announcementBar = document.querySelector(".announcement-bar");
    if (announcementBar) {
      announcementBar.style.display = "none";
    }
    lockScroll();
  };

  const { compareItems } = useSelector((state) => state.compare);
  const { wishlistItems } = useSelector((state) => state.wishlist);
  const { cartItems } = useSelector((state) => state.cart);

 
  return (
    <div className={clsx("header-right-wrap", iconWhiteClass)}>
      <div className="same-style header-search d-none d-lg-block">
        <button className="search-active" onClick={(e) => handleClick(e)}>
          {/* <i className="pe-7s-search" /> */}
          <SearchIconHeader style={{height:24 , width:24}}/>
        </button>
        <SearchInput/>
      </div>
      <div className="same-style account-setting d-none d-lg-block">
        <button
          className="account-setting-active"
          onClick={(e) => handleClick(e)}
        >
          <PersonIconHeader style={{height:24,width:24}}/>
        </button>
        <div className="account-dropdown">
          <ul>
            {customerInfo === null ? (
              <li>
                <Link>{t("txt_not_logged")}</Link>
              </li>
            ) : (
              <>
                <li>
                  {" "}
                  <Link to={process.env.PUBLIC_URL + "/my-account"}>
                    {t("txt_my_account")}
                  </Link>
                </li>
                <li>
                  <Link>{t("txt_my_orders")}</Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
      {/* <div className="same-style header-compare">
        <Link to={process.env.PUBLIC_URL + "/compare"}>
          <i className="pe-7s-shuffle" />
          <span className="count-style">
            {compareItems && compareItems.length ? compareItems.length : 0}
          </span>
        </Link>
      </div> */}
      <div className="same-style header-wishlist">
        <Link to={process.env.PUBLIC_URL + "/wishlist"}>
       <HeartIcon/>
          {/* <i className="pe-7s-like" /> */}
          <span className="count-style">
            {wishlistItems && wishlistItems.length ? wishlistItems.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style cart-wrap d-none d-lg-block">
        <button className="icon-cart" onClick={navigateToCart}>
          {/* <i className="pe-7s-shopbag" /> */}
          <ShoppingBagIcon/>
           {/* <img src={ShoppingBagIcon} style={{height:24,width:24}}/> */}
          <span className="count-style">
            {cartItems && cartItems.length ? cartItems.length : 0}
          </span>
        </button>
        {/* menu cart */}
        <MenuCart />
      </div>
      <div className="same-style cart-wrap d-block d-lg-none">
        <Link className="icon-cart" to={process.env.PUBLIC_URL + "/cart"}>
          {/* <i className="pe-7s-shopbag" /> */}
          <ShoppingBagIcon/>
           {/* <img src={ShoppingBagIcon} style={{height:24,width:24}}/> */}
          <span className="count-style">
            {cartItems && cartItems.length ? cartItems.length : 0}
          </span>
        </Link>
      </div>
      <div className="same-style mobile-off-canvas d-block d-lg-none">
        <button
          className="mobile-aside-button"
          onClick={() => triggerMobileMenu()}
        >
          <Hamburger height={28} width={28}/>
          {/* <i className="pe-7s-menu" /> */}
        </button>
      </div>
    </div>
  );
};

IconGroup.propTypes = {
  iconWhiteClass: PropTypes.string,
};

export default IconGroup;
